import { MessageBus } from '@23degrees/shared/bus';
import { ErrorService } from '@23degrees/shared/services/error/error.service';
import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class TrackerService {
  private messageBus = inject(MessageBus);
  private platform = inject(PLATFORM_ID);

  isServer = isPlatformServer(this.platform);

  postClickAction(action = 'none', contentId = 'none') {
    const timestamp = Date.now() || new Date();
    this.postMessage({ action, contentId, timestamp });
  }

  postMessage(params: Object) {
    if (!this.isServer) {
      try {
        if (window?.parent) {
          window.parent.postMessage(params, '*');
        }
      } catch (error) {
        console.log('PostMessage Error', ErrorService);
      }
    }
  }
}
